import React from "react";
import "./NotFound.scss";

const NotFoundPage = ({ history }) => {
  return (
    <div className="notfound">
      <div>
        <span>404</span>
        <span>Page not found</span>
        <span>
          The link you clicked on may be broken or the page may have been
          removed or renamed
        </span>
        <div onClick={history.goBack}>Go Back</div>
      </div>
    </div>
  );
};

export default NotFoundPage;
